export default __webpack_public_path__ + "static/media/icon2.6c1e7b07.png";